import gsap from "gsap";

window.addEventListener("load", () => {
   const DELAY = 0.075;

   const elements = document.querySelectorAll('.fade-up');
   let k = 0;
   for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.classList.contains("reset-animation")) {
         k = 0;
      }

      gsap.to(
         element,
         {
            transform: "perspective(1000px) translate3d(0, 0, 0)",
            opacity: 1,
            duration: 1.7,
            delay: DELAY * k,
            ease: "expo.out",
         }
      );

      k++;
   }
});
